import { render, staticRenderFns } from "./VideoContent.vue?vue&type=template&id=31f3456c&"
import script from "./VideoContent.vue?vue&type=script&lang=ts&"
export * from "./VideoContent.vue?vue&type=script&lang=ts&"
import style0 from "./VideoContent.vue?vue&type=style&index=0&id=31f3456c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports